<nav class="navbar navbar-expand-md navbar-dark fixed-top bg-dark">
  <div class="container">
    <a class="navbar-brand" [routerLink]="['/']">
      {{ appName }}
    </a>
    <button
      class="navbar-toggler"
      type="button"
      data-toggle="collapse"
      data-target="#navbarsExampleDefault"
      aria-controls="navbarsExampleDefault"
      aria-expanded="false"
      aria-label="Toggle navigation"
    >
      <span class="navbar-toggler-icon"></span>
    </button>

    <div class="collapse navbar-collapse" id="navbarsExampleDefault">
      <ul class="navbar-nav mr-auto">
        <li class="nav-item">
          <!-- Hide this link for unregistered users, i.e. show only if logged in -->

          <a
            class="nav-link ml-4 lead"
            [routerLink]="['/about']"
            *ngIf="loggedin"
            >How it works</a
          >
        </li>
        <!-- <li class="nav-item pt-1">
        <button
          class="btn btn-md btn-outline-success"
          [routerLink]="['/signup']"
          *ngIf="!loggedin"
        >
          Sign Up
        </button>
      </li> -->
        <li class="nav-item">
          <a
            class="nav-link ml-4 lead"
            [routerLink]="[
              '/dashboard',
              { outlets: { dashoutlet: ['profile'] } }
            ]"
            *ngIf="loggedin"
            >Dashboard</a
          >
        </li>
      </ul>
      <form class="form-inline input-group-sm pt-2 pt-lg-0">
        <input
          class="form-control mr-sm-2"
          type="text"
          placeholder="e-mail"
          *ngIf="!loggedin"
          id="email"
          [(ngModel)]="email"
          name="email"
        />
        <input
          class="form-control mr-sm-2"
          type="password"
          placeholder="password"
          *ngIf="!loggedin"
          id="pwd"
          [(ngModel)]="pass"
          name="pwd"
        />
        <button
          class="btn btn-sm btn-outline-success mt-2 mt-sm-0"
          type="submit"
          *ngIf="!loggedin"
          (click)="login()"
        >
          Log In
        </button>
        <button
          class="btn btn-sm btn-outline-success mt-2 mt-sm-0 ml-2"
          [routerLink]="['/signup']"
          *ngIf="!loggedin"
        >
          Sign Up
        </button>
        <p class="lead text-white mb-0 pb-1 ml-3" *ngIf="loggedin">
          {{ userName }}
        </p>
        <button
          class="btn btn-sm btn-outline-warning ml-3"
          id="signout"
          *ngIf="loggedin"
          (click)="logout()"
        >
          Sign Out
        </button>
      </form>
    </div>
  </div>
</nav>
